import { type PlanType as _PlanType } from '@/types';

import { PAYMENT_URLS } from '../constants/paymentUrls';

export type PaidPlanType = Exclude<_PlanType, 'FREE'>;

export const getPaymentEntryUrl = (
  plan: PaidPlanType | string,
  countryCode?: string,
) => {
  return countryCode === 'KR'
    ? PAYMENT_URLS.getMethodsUrl(plan)
    : PAYMENT_URLS.getCheckoutUrl(plan);
};

export const getPaymentLoginUrl = (
  plan: PaidPlanType | string,
  countryCode?: string,
) => {
  const callbackUrl = getPaymentEntryUrl(plan, countryCode);
  return `/login?callbackUrl=${encodeURIComponent(callbackUrl)}`;
};
